export default __webpack_public_path__ + "media/images/socials-youtube-27e0461cba7533c867349e0597f945a7.svg";